export const SALUTATIONS = ['Mr.', 'Mrs.', 'Ms.', 'Mdm.', 'Dr.', 'Prof.', 'Rev.', 'Pastor']

export const PROFESSIONAL_ROLES = [
  'Psychologist',
  'Doctoral-level psychologist',
  'Psychiatrist',
  'Mental health / marriage counselor',
  'Licensed professional counselor (LPC or equivalent)',
  'Licensed marriage and family therapist (LMFT or equivalent)',
  'Social worker',
  'Church pastor',
  'Pastoral counselor / lay counselor / lay marriage mentor',
  'Relationship coach',
  'Counseling student/trainee',
  'Others',
]
